import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './WizardFooter.css';

export const WIZARD_FOOTER_HEIGHT = 75;

const WizardFooter = React.memo(({ leftComponents = [], buttons = [], containerClass = '' }) => {
    return (
        <div className={classNames(css.container, containerClass)} style={{ height: `${WIZARD_FOOTER_HEIGHT}px` }}>
            <div className={css.leftContainer}>{leftComponents}</div>
            <div className={css.buttonsContainer}>
                {buttons.map((button, index) => {
                    return (
                        <div key={`footerButton_${index}`} className={css.buttonHolder}>
                            {button}
                        </div>
                    );
                })}
            </div>
        </div>
    );
});

WizardFooter.propTypes = {
    leftComponents: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
    buttons: PropTypes.arrayOf(PropTypes.element),
    containerClass: PropTypes.string,
};

export default WizardFooter;
